import { v4 as uuidv4 } from "uuid";
import { Button, Card, CardContent, Grid } from "@mui/material";
import {
  ConfirmDangerModalComponent,
  DocumentTips,
  ErrorModal,
  UploadWidget,
} from "@soqs/common";

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PAGES } from "../App";
import { uploadfiles } from "../features/API";
import { cancel, setConfirmMessage, setPage } from "../features/AppSlice";
import { config } from "../config";

const UploadDocs = () => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState({});
  const [uploading, setUploading] = useState(false);
  const [confirmClearModal, setConfirmClearModal] = useState(false);
  const [errors, setErrors] = useState(null);
  const [bypassValidation] = useState(false);
  const [disabledUpload, setDisabledUpload] = useState(true);
  const [validating, setValidating] = useState(0);

  const upload = (fg) => {
    let files_to_upload = [];
    for (let filegroup in fg) {
      for (let file of fg[filegroup]) {
        let nf = new File([file], filegroup + "_" + file.name, {
          type: file.type,
        });
        files_to_upload.push(nf);
      }
    }
    setUploading(true);
    uploadfiles(files_to_upload)
      .then((data) => {
        setUploading(false);
        if (data.error) {
          setErrors(data);
        } else {
          dispatch(setConfirmMessage(data));
          dispatch(setPage(PAGES.Confirmation));
        }
      })
      .catch((err) => {
        setUploading(false);
        setErrors(err);
      });
  };
  let [sections, setSections] = useState([
    {
      set: "document",
      value: "1",
      description: "Document",
      info: "",
      seq: 0,
      id: uuidv4(),
    },
  ]);

  const calculate_delete = (sections, files_l) => {
    let to_delete = [];
    for (let i = 0; i < sections.length - 1; i++) {
      let j = sections[i].id;
      if (!files_l[j] || files_l[j].length === 0) {
        to_delete.push(j);
      }
    }
    return to_delete;
  };

  const setFilesAndCheck = (files_l) => {
    let disabled = false;

    let all_others_full = false;
    let count_others = 0;

    let to_delete = calculate_delete(sections, files_l);
    let new_sections = [...sections];
    while (to_delete.length > 0) {
      let j = new_sections.findIndex((x) => x.id == to_delete[0]);
      new_sections.splice(j, 1);
      delete files_l[to_delete[0]];
      to_delete = calculate_delete(new_sections, files_l);
    }
    let count_sections = new_sections.filter((x) => x.value !== "0").length;
    //console.log("count_sections " + count_sections);
    for (let fg in files_l) {
      if (new_sections.filter((x) => x.id === fg)?.[0].value === "0") {
        continue;
      }
      if (files_l[fg].length > 0) {
        count_others++;
        all_others_full = true;
      }
    }
    // console.log("count_sections " + count_sections);
    all_others_full = all_others_full && count_others === count_sections;

    // console.log("all_others_full " + all_others_full);
    // console.log("count_others " + count_others);
    // console.log("count_sections " + count_sections);
    let do_add = all_others_full && count_others < /*max_others*/ 10;
    // console.log("do_add " + do_add);

    //setSections(new_sections);
    if (do_add) {
      setSections([
        ...new_sections.map((s, i) => {
          s.description = `Document ${i + 1}`;
          return s;
        }),
        {
          set: "document",
          value: "1",
          description: "Document",
          info: "",
          seq: 0,
          id: uuidv4(),
        },
      ]);
    } else {
      setSections(
        new_sections.map((s, i) => {
          s.description = `Document ${i + 1}`;
          return s;
        })
      );
    }
    setFiles(files_l);
    setDisabledUpload(disabled);
  };

  return (
    <>
      <Grid container spacing={2} direction="column">
        <Grid>
          <DocumentTips />
        </Grid>
        {sections?.map((i, idx) => (
          <UploadWidget
            key={i.id}
            sectionIndex={idx}
            sectionName={i?.description}
            sectionInfo={i?.info}
            cbSetFiles={(f) => {
              let newf = files;
              newf[`${i.id}`] = f;
              setFilesAndCheck(newf);
            }}
            setErrors={setErrors}
            otherFiles={Object.entries(files)
              .filter(([id]) => id !== String(idx))
              .flatMap(([, f]) => f)}
            cbValidating={(busy) => setValidating((v) => v + (busy ? 1 : -1))}
            validation={
              config.ENVIRONMENT === "development" ||
              config.ENVIRONMENT === "qadebug"
                ? !bypassValidation
                : undefined
            }
          />
        ))}
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Card>
          <CardContent>
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="space-between"
            >
              <Grid>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setConfirmClearModal(true);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid>
                <Button
                  variant="contained"
                  color="primary"
                  loading={uploading || validating > 0}
                  onClick={() => {
                    upload(files);
                  }}
                  disabled={
                    validating > 0 ||
                    ((config.ENVIRONMENT === "development" ||
                      config.ENVIRONMENT === "qadebug") &&
                    bypassValidation
                      ? false
                      : disabledUpload)
                  }
                >
                  Submit to SARS
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <ConfirmDangerModalComponent
          open={confirmClearModal}
          onClose={() => {
            setConfirmClearModal(false);
          }}
          cbConfirm={() => {
            setConfirmClearModal(false);
            dispatch(cancel());
          }}
          title="Cancel Uploading"
          subheader="Are you sure you want to cancel the upload and return to the previous page?"
          confirmText="Cancel Uploading"
          cancelText="Continue Uploading"
        />
        {/* Localerror modal required to prevent rerender as the uploading is not controlled by redux as per redux best practises */}
        <ErrorModal
          title={
            errors?.errortitle
              ? errors?.errortitle
              : typeof errors?.error === "string" &&
                  errors?.error?.indexOf("|") > -1
                ? errors?.error?.split("|")[0]
                : "Error"
          }
          open={errors !== null}
          onClose={() => {
            if (errors?.fatal) {
              dispatch(cancel());
            } else {
              setErrors(null);
            }
          }}
          subheader={
            Array.isArray(errors?.error) ? (
              <ul>
                {errors?.error.map((e, idx) => (
                  <li key={idx}>{e.replace("- ", "")}</li>
                ))}
              </ul>
            ) : (
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    errors?.error?.indexOf("|") > -1
                      ? errors?.error?.split("|")[1]
                      : errors?.error,
                }}
              ></p>
            )
          }
        />
      </Grid>
    </>
  );
};

export default UploadDocs;
